var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg004(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 99,
    height: 15.544,
    viewBox: "0 0 99 15.544",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    transform: "translate(-24.764 -24.974)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1981",
    "data-name": "Path 1981",
    d: "M24.764,32.945l6.876,6.879,1.306-1.316-8.179-8.173,1.416-1.416L34.372,37.1l1.412-1.423-8.189-8.174,1.421-1.43,8.192,8.185,1.3-1.307-6.868-6.867h8.395V37.529a3.681,3.681,0,0,1-1.15,2.672A4.269,4.269,0,0,1,36,41.351H24.764Z",
    transform: "translate(0 -0.832)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    transform: "translate(46.069 24.974)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1982",
    "data-name": "Path 1982",
    d: "M161.982,36.548a5.512,5.512,0,0,1-5.859-5.787,5.861,5.861,0,1,1,11.719,0,5.512,5.512,0,0,1-5.859,5.787Zm0-9.085a2.454,2.454,0,0,0-2.131,1.026,3.82,3.82,0,0,0-.632,2.271,3.821,3.821,0,0,0,.632,2.271,2.724,2.724,0,0,0,4.262,0,3.82,3.82,0,0,0,.632-2.271,3.82,3.82,0,0,0-.632-2.271A2.454,2.454,0,0,0,161.982,27.463Z",
    transform: "translate(-145.239 -24.974)",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1983",
    "data-name": "Path 1983",
    d: "M210.7,37.129h-2.966V26.114h5.939a5.175,5.175,0,0,1,2.839.71,2.681,2.681,0,0,1,1.288,2.392,3.006,3.006,0,0,1-.462,1.651,2.668,2.668,0,0,1-1.387,1.111v.031q1.519.34,1.717,2.638.049.633.115,1.265a2.185,2.185,0,0,0,.38,1.219h-3.072a4.767,4.767,0,0,1-.312-1.759,4.01,4.01,0,0,0-.346-1.543,1.459,1.459,0,0,0-1.37-.71H210.7Zm2.478-8.716H210.7V30.9h2.61q1.42,0,1.42-1.3Q214.73,28.413,213.179,28.413Z",
    transform: "translate(-184.204 -25.835)",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1984",
    "data-name": "Path 1984",
    d: "M341.593,29.17h-.033l-1.337,3.857H342.9Zm-2.823,7.961h-3.153l4.408-11.016h3.12l4.408,11.016h-3.2l-.726-1.975h-4.111Z",
    transform: "translate(-280.75 -25.835)",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1985",
    "data-name": "Path 1985",
    d: "M303.118,27.557a2.169,2.169,0,0,0-.516-.176,2.413,2.413,0,0,0-.644-.068c-.97-.017-1.418.28-1.428.852-.006.316.3.6,1.007.837q1.148.294,2.3.6a6.634,6.634,0,0,1,2.309,1.038,2.614,2.614,0,0,1,1.038,2.2,3.126,3.126,0,0,1-1.651,2.859,6.889,6.889,0,0,1-7.154-.233,2.883,2.883,0,0,1-1.186-1.48l-.018-.049,2.607-.883.021.032a2.385,2.385,0,0,0,1.553,1.116,4.293,4.293,0,0,0,.876.1c.029,0,.059,0,.087,0a2.654,2.654,0,0,0,1.163-.338.947.947,0,0,0,.573-.845c.021-.38-.27-.755-.986-.956q-1.133-.309-2.282-.633a6.836,6.836,0,0,1-2.324-1.038,2.6,2.6,0,0,1-1.055-2.2,2.85,2.85,0,0,1,1.614-2.556,6.319,6.319,0,0,1,3.224-.711,5.72,5.72,0,0,1,3.2.9,3.082,3.082,0,0,1,1.006,1.057l.027.047-2.408,1.187-.025-.036A2.027,2.027,0,0,0,303.118,27.557Z",
    transform: "translate(-251.724 -25.012)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1986",
    "data-name": "Path 1986",
    d: "M259.952,26.115h3.071v6.521a4.774,4.774,0,0,1-1.222,3.6,7.049,7.049,0,0,1-7.809.015,4.789,4.789,0,0,1-1.238-3.611V26.115h3.071v6.691q0,2.145,2.063,2.145t2.064-2.145Z",
    transform: "translate(-218.192 -25.835)",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1987",
    "data-name": "Path 1987",
    d: "M390.158,37.143h-2.89V26.124h3.154l4.1,6.79h.033v-6.79h2.89V37.143h-3.154l-4.1-6.867h-.033Z",
    transform: "translate(-319.745 -25.842)",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1988",
    "data-name": "Path 1988",
    d: "M117.237,32.3h-2.459v2.53h2.459q1.651,0,1.651-1.234Q118.888,32.3,117.237,32.3Zm.132,4.829h-5.662V26.114h5.513q4.259,0,4.259,2.762a2.352,2.352,0,0,1-1.551,2.221,2.629,2.629,0,0,1,2.03,2.607Q121.958,37.129,117.369,37.129Zm-.215-8.794h-2.377v2.113h2.377a1.452,1.452,0,0,0,.825-.232.912.912,0,0,0,.429-.817Q118.409,28.335,117.154,28.336Z",
    transform: "translate(-111.707 -25.835)",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg004);
export default __webpack_public_path__ + "static/media/004.2fe8af69facd466bbdf5f8ee532b624e.svg";
export { ForwardRef as ReactComponent };